const CACHE_KEY = 'cachedCartContent';
const CACHE_DURATION = 120000; // 2 minutes in milliseconds

function cacheEnabled(data) {
  const isBifrost = window._be_platform === 'bifrost';
  const isDisabled = window._disableCartCache === true;
  const isValidData = typeof data === 'string' && data.trim().length > 0;

  return !isBifrost && !isDisabled && isValidData;
}

export function getCachedCart() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (!cached) {
    return '';
  }

  const { data, expiryTime } = JSON.parse(cached);
  const cacheExpired = new Date().getTime() > expiryTime;

  if (cacheExpired) {
    return '';
  }
  
  return data;
}

export function setCachedCart(data:string) {
  if (!cacheEnabled(data)) {
    return;
  }

  const expiryTime = new Date().getTime() + CACHE_DURATION;

  localStorage.setItem(CACHE_KEY, JSON.stringify({ data, expiryTime }));
}

export function clearCachedCart() {
  localStorage.removeItem(CACHE_KEY);
}